import { useEffect } from "react";

/** Require user confirmation when navigating away from the page. */
export const useBlockUnload = (blocking: boolean = true) => {
  useEffect(() => {
    const listener = (evt: BeforeUnloadEvent) => {
      evt.preventDefault();
      return (evt.returnValue = "Are you sure you want to leave?");
    };

    if (blocking) window.addEventListener("beforeunload", listener);

    return () => {
      window.removeEventListener("beforeunload", listener);
    };
  }, [blocking]);
};
